import React from "react"
import { Link as LinkRouter } from "react-router-dom"

import { Button, Grid, Typography } from "@material-ui/core"
import { Portlet } from "@/components"
import { Add } from "@material-ui/icons"

import useStyles from "@/pages/Admin/TrackableLinks/EmptyTrackableLinksList/styles"

const EmptyTrackableLinksList: React.FC = () => {
	const classes = useStyles()

	return (
		<Portlet style={{ boxShadow: "none", padding: 36 }}>
			<Grid container justifyContent="center" alignItems="center">
				<Grid item alignItems="center" className={classes.item}>
					<Grid container spacing={2} justifyContent="center" alignItems="center">
						<Grid item>
							<Typography variant="h4" className={classes.text}>
							Nenhum link cadastrado 😥
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1" className={classes.description}>
							Você ainda não cadastrou nenhum link rastreável. Que tal cadastrar um agora mesmo?! Clique no botão abaixo:
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Button
								variant="contained"
								color="primary"
								className={classes.button}
								component={LinkRouter}
								to={"/admin/conversion/tools/trackable-links/create"}
								startIcon={<Add />}
							>
							Adicionar novo link
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default EmptyTrackableLinksList
